"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Register2_1 = require("./Register2");
exports.Register2 = Register2_1.Register2;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy90ZXN0L1NhbXBsZS9wYXJ0cy9IZWFsdGhIaXN0b3J5L3BhcnRzL1JlZ2lzdGVyMi9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLHlDQUFxQztBQUE3QixnQ0FBQSxTQUFTLENBQUEifQ==